import $ from 'jquery';
import TagManagerUtil from '@component/common/src/util/TagManagerUtil';

function listentoCloseonClickedOutsideBag() {
  $(document).on('click.quickbagclickoutside', 'body', (event) => {
    const target = event.target;
    if (target.id !== '#qbFlyout') {
      const withinFlyout = $.contains(
        document.getElementById('qbFlyout'),
        event.target,
      );
      if (!withinFlyout) {
        $('#bagContainer').removeClass('show');
        $(document).off('.quickbagclickoutside');
      }
    }
  });
}
export default function setClickActioninQuickBagButton() {
  $('#bagContainer').addClass('openOnClick');
  $('#m-bag-count-anchor').off('click');
  $('#m-bag-count-anchor').on('click', (event) => {
    $('#bagContainer').toggleClass('show');
    event.preventDefault();
    listentoCloseonClickedOutsideBag();
    if (!$('#bagContainer').hasClass('show')) {
      $(document).off('.quickbagclickoutside');
    } else {
      TagManagerUtil.fireTag('link', { event_name: 'minibag click', link_name: 'minibag click' });
    }
    return false;
  });
  $('.bag-overlay').on('click', () => {
    $('#bagContainer').removeClass('show');
    $(document).off('.quickbagclickoutside');
  });
}
